export default {
    "hd": "Hoạt động",
    "dhd": "Dừng hoạt động",
    "csd": "Chưa sử dụng",
}
